  <script>
import http from '@/service/http'
import {mapState} from 'vuex'

export default {
  name: 'Form',
  data () {
    return {
      usuarios: [{}],
      tarefa: {
        id: '',
        tarefa: '',
        dia: '',
        hora: '',
        usuario_id: '',
        orcamento_id: '',
        descricao: '',
        os_id: '',
        status_id: 1,
        envolvidos: [],
        anexos: []
      },
      progress: 0,
      errorFile: false,
      options: {
        url: `${process.env.API_URL}/upload-file`,
        uploadMultiple: false,
        acceptedFiles: '',
        headers: {
          path: 'tarefa',
          accept: 'all'
        }
      }
    }
  },
  mounted () {
    this.fecth()
  },
  watch: {
    '$route' () {
      if (this.$route.params.id != null) {
        this.fecth()
      }
    },
    hasAll () {
      if (this.hasAll) {
        this.all = true
      } else {
        this.all = false
      }
    }
  },
  methods: {
    totalProgress (progress, totalBytes, bytesSent) {
      this.progress = progress
    },
    complete (files, status, xhr) {
      if (files.errorMessage) {
        this.errorFile = true
      } else {
        this.errorFile = false
        this.tarefa.anexos.push({anexo: xhr.response, legenda: files.name})
        this.$nextTick(() => {
          window.Materialize.updateTextFields()
        })
        this.progress = 0
      }
    },
    destroyAnexo (indexAnexo) {
      this.$swal({
        title: 'Atenção',
        text: `excluir uma anexo é uma operação irreversível`,
        type: 'warning',
        showCancelButton: true,
        cancelButtonText: 'Cancelar',
        cancelButtonColor: '#d33',
        confirmButtonColor: '#3085d6',
        confirmButtonText: 'Sim, quero excluir!',
        reverseButtons: true
      }).then(() => {
        if (!this.tarefa.anexos[indexAnexo].id) {
          this.tarefa.anexos.splice(indexAnexo, 1)
          window.Materialize.toast('Anexo excluído!', 4000)
        } else {
          http.delete(`tarefas/anexo/${this.tarefa.anexos[indexAnexo].id}`)
            .then(response => response.data)
            .then(data => {
              window.Materialize.toast('Anexo excluído!', 4000)
              this.tarefa.anexos.splice(indexAnexo, 1)
            })
        }
      })
    },
    validate () {
      this.$validator.validateAll().then(success => {
        if (!success) {
          this.$swal({
            title: 'Ops, encontramos um erro!',
            html: 'Um ou mais campos estão com seu preenchimento incorreto',
            type: 'error',
            cancelButtonText: 'Ok'
          })
          return false
        } else {
          this.submit()
        }
      })
    },
    selectStatus: function (value) {
      this.tarefa.status_id = parseInt(value)
    },
    async submit () {
      const verb = this.isNew ? 'post' : 'put'
      const url = this.isNew ? '/tarefas' : `/tarefas/${this.tarefa.id}`
      const {data} = await http[verb](url, this.tarefa)
      if (data != null) {
        this.$emit('update-tarefas-list', {tarefa: data.tarefa})
        this.$router.push({name: 'tarefas.index'})
      }
    },
    async fecth () {
      this.clear()
      const {id} = this.$route.params
      if (id !== undefined) {
        const {data} = await http.get(`/tarefas/${id}/edit`)
        this.tarefa = data.tarefa
        this.usuarios = data.usuarios
      } else {
        const {data} = await http.get(`/tarefas/create`)
        this.usuarios = data.usuarios
      }
      setTimeout(function () {
        window.Materialize.updateTextFields()
      }, 0)
    },
    clear () {
      this.tarefa = {
        id: '',
        tarefa: '',
        dia: '',
        hora: '',
        usuario_id: '',
        orcamento_id: '',
        descricao: '',
        os_id: '',
        status_id: 1,
        anexos: [],
        envolvidos: []
      }
    }
  },
  computed: {
    ...mapState(['loading']),
    isNew () {
      return this.tarefa.id === ''
    },
    api_url () {
      return process.env.UPLOADS_URL
    },
    tarefaEnvolvidos: {
      get () {
        return this.usuarios.filter(
          option => this.tarefa.envolvidos.includes(option.id)
        )
      },
      set (newSelectedOptions) {
        this.tarefa.envolvidos = newSelectedOptions.map(option => option.id)
      }
    }
  }
}
</script>

<template>
  <div>

    <form @submit.prevent="validate">

      <div class="row">

        <div class="col s12 m10 offset-m1">

          <div class="row">
            <div class="input-field col s12 m7">
              <input name="tarefa" id="tarefa" type="text" v-validate
                     data-vv-rules="required" :class="{invalid: errors.has('tarefa')}"
                     v-model="tarefa.tarefa">
              <label for="tarefa">*Tarefa</label>
              <small class="red-text">{{ errors.first('tarefa') }}</small>
            </div>

            <div class="input-field col s12 m3">
              <i class="material-icons prefix">event</i>
              <input name="dia" id="icon_dia" type="date" v-validate data-vv-rules="required" :class="{invalid: errors.has('dia')}" v-model="tarefa.dia" :data-value="tarefa.dia">
              <label for="icon_dia" class="active">*Prazo dia</label>
              <small class="red-text">{{ errors.first('dia') }}</small>
            </div>

            <div class="input-field col s12 m2">
              <i class="material-icons prefix">alarm</i>
              <input name="hora" id="icon_hora" type="text" v-time v-validate data-vv-rules="required" :class="{invalid: errors.has('hora')}" v-model="tarefa.hora" :data-value="tarefa.hora">
              <label for="icon_hora">*hora</label>
              <small class="red-text">{{ errors.first('hora') }}</small>
            </div>

          </div>

          <div class="row">
            <div class="input-field col s12 m2">
              <input name="os_id" id="os_id" type="number" v-validate data-vv-rules="integer" :class="{invalid: errors.has('os_id')}" v-model="tarefa.os_id">
              <label for="os_id"># OS</label>
              <small class="red-text">{{ errors.first('os_id') }}</small>
            </div>

            <div class="input-field col s12 m2">
              <input name="os_id" id="orcamento_id" type="number" v-validate data-vv-rules="integer" :class="{invalid: errors.has('orcamento_id')}" v-model="tarefa.orcamento_id">
              <label for="orcamento_id"># Orçamento</label>
              <small class="red-text">{{ errors.first('orcamento_id') }}</small>
            </div>

            <div class="col s12 m6">
              <label>Usuários Envolvidos na Tarefa</label>
              <multiselect multiple placeholder="Selecione" :closeOnSelect="false" v-model="tarefaEnvolvidos" label="nome_completo" track-by="id"  :options="usuarios"></multiselect>
            </div>

            <div class="col s12 m2">
              <label for="status_id">*Status</label>
              <select name="status_id" id="status_id" v-validate data-vv-rules="required" v-model="tarefa.status_id">
                <option value="1">Agendada</option>
                <option value="2">Em execução</option>
                <option value="3">Finalizada</option>
              </select>
              <small class="red-text">{{ errors.first('status_id') }}</small>
            </div>

          </div>

          <div class="row">
            <div class="input-field col s12">
              <textarea name="descricao" id="descricao" class="materialize-textarea" v-model="tarefa.descricao"></textarea>
              <label for="descricao">Descrição</label>
              <small class="red-text">{{ errors.first('descricao') }}</small>
            </div>
          </div>

          <div class="row">
            <div class="col s12 m6 center-align" v-for="(anexo, indexAnexo) in tarefa.anexos" :key="indexAnexo">
              <div class="row">
                <div class="col s12 m2">
                  <br>
                  <a :href="`${api_url}/tarefa/${anexo.anexo}`" target="_blank"><i class="material-icons">file_download</i></a>
                </div>
                <div class="input-field col s12 m7">
                  <input name="legenda" :id="`legenda-${indexAnexo}`" type="text"
                         v-model="anexo.legenda"/>
                  <label :for="`legenda-${indexAnexo}`">Legenda</label>
                </div>
                <div class="col s12 m2">
                  <br>
                  <a href="#" @click.prevent="destroyAnexo(indexAnexo)">
                    <i class="material-icons red-text">delete_forever</i>
                  </a>
                </div>
              </div>
              <br clear="all"/>
            </div>
          </div>

          <div class="row">

            <div class="col s12 m3">

              <vue-clip :options="options" :on-complete="complete" :on-total-progress="totalProgress">
                <template slot="clip-uploader-action">
                  <div class="row">
                    <div class="col s12">
                      <div class="dz-message">
                        <div class="card center">
                          <span class="card-title">Anexo</span>
                        </div>
                      </div>
                      <div class="progress">
                        <div class="determinate" :style="`width: ${progress}%`"></div>
                      </div>
                      <div v-if="errorFile" class="center-align">Tipo de arquivo inválido</div>
                      <div v-if="tarefa.anexo" class="center-align">
                        <i class="material-icons pointer" @click.prevent="destroyImage()">delete_forever</i>
                        <a :href="`${api_url}/tarefa/${tarefa.anexo}`" target="_blank"><i
                          class="material-icons pointer">search</i></a>
                      </div>
                    </div>
                  </div>
                </template>
              </vue-clip>

            </div>

          </div>

          <div class="row">

            <div class="input-field col s12">
              <button class="waves-effect waves-light btn" :disabled="loading">Salvar</button>
            </div>

          </div>

        </div>

      </div>

    </form>

  </div>
</template>



// WEBPACK FOOTER //
// src/features/tarefas/tarefas/form.vue